import { render, staticRenderFns } from "./FeedSidebar.vue?vue&type=template&id=0fecc2d8&scoped=true&"
import script from "./FeedSidebar.vue?vue&type=script&lang=ts&"
export * from "./FeedSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./FeedSidebar.vue?vue&type=style&index=0&id=0fecc2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fecc2d8",
  null
  
)

export default component.exports